import { Outlet } from 'react-router'

import { ReconnectBanner } from '@/features/auth/components/reconnect-banner'
import { TrialBanner } from '@/features/billing/components/trial-banner'

import { AppRail } from './app-rail'

export function AppLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background md:flex-row">
      <AppRail />
      <main className="min-w-0 flex-1">
        <div className="sticky top-0 z-30">
          <ReconnectBanner />
          <TrialBanner />
        </div>
        <Outlet />
      </main>
    </div>
  )
}
